__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-02-04-1770191028-stable-dev/";